// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca, catálogo e o
// carregador da tela. Outro módulo usa a `public.ts`.
export { COMMUNICATION_SETTING_PATH, communicationSettingListScreen } from './communication-setting.screen';
export { communicationSettingSearch } from './communication-setting.search';
export { loadCommunicationSettingMessages, loadCommunicationSettingScreen } from './public';

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadCommunicationSettingGuides = () => import('./communication-setting.guide');
